import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import {useApiNotification} from "../ui/ApiNotificationProvider";
import {deleteOrganizationUnit} from "../../api/organization-unit-functions";


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    label: {
        flexGrow: 1,
        margin: 'auto'
    },
    actions: {
        display: 'flex'
    },
    deleteBtn: {
        color: theme.palette.error.main
    },
    addBtn: {
        color: theme.palette.success.main
    }
}));

const OrganizationUnitTreeView = ({
                                      unit,
                                      onAdd,
                                      onEdit,
                                      disableDelete,
                                      onDeleted,
                                      disableProcessingAction,
                                      onProcessingAction
                                  }: any) => {
    const classes = useStyles();
    const {handleError, showSuccess, handleErrors} = useApiNotification();

    const addHandler = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        onAdd();
    };

    const editHandler = (e: any) => {
        e.stopPropagation();
        e.preventDefault();
        onEdit();
    };

    const deleteHandler = async (e: any, deletedUnit: any) => {
        e.stopPropagation();
        e.preventDefault();
        onProcessingAction(true)
        await deleteOrganizationUnit(deletedUnit.organizationId, deletedUnit.id)
            .then(errors => {
                if (errors.length == 0) {
                    showSuccess();
                    onDeleted()
                } else {
                    handleErrors(errors, '_Common.Api.Messages.OrganizationUnitWithContentCannotBeRemoved');
                }
            })
            .catch(handleError)
            .finally(() => onProcessingAction(false));
    };

    return <div className={classes.root}>
        <div className={classes.label}>{unit.name}</div>
        <div className={classes.actions}>
            <IconButton disabled={disableProcessingAction} aria-label="edit" onClick={editHandler}>
                <EditIcon/>
            </IconButton>
            <IconButton disabled={disableProcessingAction} aria-label="add" className={classes.addBtn}
                        onClick={addHandler}>
                <AddIcon/>
            </IconButton>
            <IconButton disabled={disableDelete || disableProcessingAction} aria-label="delete"
                        className={classes.deleteBtn} onClick={(e) => deleteHandler(e, unit)}>
                <RemoveCircle/>
            </IconButton>
        </div>
    </div>;
};

export default OrganizationUnitTreeView;
